import React, { useEffect, useState } from 'react'
import DisplayCard from '../../components/DisplayCard';
import { useNavigate } from 'react-router-dom';
import { getAllChallengesIds } from '../../services/api/challenges/getChallenge';
import { removeChallenge } from '../../services/api/challenges/removeChallenge';
import FilledButton from '../../components/ui/FilledButton';

const Challenges = () => {
    const [challengesList, setChallengesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getAllChallengesIds().then(response => {
            // console.log(response);
            if (response.error === null) {
                setChallengesList(response.data);
                setIsLoading(false);
            }
        })
    },[]);

    const navigate = useNavigate();

    const handleCourseEdit = (id) => {
        navigate(`/challenges/edit/${id}`);
    }

    const handleCourseDelete = async (id) => {
        const isConfirmed = window.confirm('Are you sure u want to delete this challenge');
        if (isConfirmed) {
            const res = await removeChallenge(id);
            if (res.error === null) {
                alert('Deleted challenge successfully');
            }else{
                alert('an error occurred');
            }
        }
    }

  return (
    <>
    <div className='flex justify-end items-center p-2'><FilledButton label={'create challenge'} onClick={() => navigate('/challenges/create')} /></div>
    <div className='flex gap-4 items-center flex-wrap'>
        {
            isLoading?'Loading...':challengesList?.map((course,ind) => <DisplayCard key={ind} title={course?.title} handleDelete={() => handleCourseDelete(course?.challenge_id)} handleEdit={() => handleCourseEdit(course?.challenge_id)} />)
        }
    </div>
        </>
  )
}

export default Challenges
 